<app-side-menu>
  <div class="suppliers-content">
    

    <!-- Filtros -->
    <div class="row">
      <div class="col-12">
        <div class="filters-section">
          <div class="filters-row">
            <div class="filter-group">
              <label for="statusFilter" class="form-label">Filtrar por Status:</label>
              <div *ngIf="loadingStatuses" class="loading-statuses">
                <i class="fas fa-spinner fa-spin me-2"></i>
                Carregando status...
              </div>
              <select
                *ngIf="!loadingStatuses"
                id="statusFilter"
                class="form-select"
                [(ngModel)]="filters.status"
                (change)="applyFilters()">
                <option *ngFor="let option of statusOptions" [value]="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>

            <div class="filter-group">
              <label for="categoryFilter" class="form-label">Filtrar por Categoria:</label>
              <select
                id="categoryFilter"
                class="form-select"
                [(ngModel)]="filters.category"
                (change)="applyFilters()">
                <option *ngFor="let option of categoryOptions" [value]="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>

            <div class="filter-group">
              <label for="stateFilter" class="form-label">Filtrar por Estado:</label>
              <select
                id="stateFilter"
                class="form-select"
                [(ngModel)]="filters.state"
                (change)="applyFilters()">
                <option *ngFor="let option of stateOptions" [value]="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>

            <div class="filter-actions">
              <button
                type="button"
                class="btn btn-outline-secondary"
                (click)="clearFilters()">
                <i class="fas fa-times me-2"></i>
                Limpar Filtros
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Conteúdo Principal -->
    <div class="row">
      <div class="col-12">
        <div class="suppliers-card">
<!-- Estado vazio -->
          <div *ngIf="!isLoading && (!filteredSuppliers || filteredSuppliers.length === 0)" class="empty-state">
            <i class="fas fa-truck"></i>
            <h3>Nenhum fornecedor encontrado</h3>
            <p>Comece cadastrando seu primeiro fornecedor para gerenciar seus parceiros comerciais.</p>
            <app-button 
              text="Cadastrar Primeiro Fornecedor"
              color="var(--primary-color)"
              (buttonClick)="newSupplier()"
              className="btn-primary">
              <i class="fas fa-plus me-2"></i>
            </app-button>
          </div>

          <!-- Tabela de fornecedores -->
          <div *ngIf="filteredSuppliers && filteredSuppliers.length > 0" class="suppliers-table">
            <div class="table-content">
              <app-table
                [title]="tableTitle"
                [data]="filteredSuppliers"
                [loading]="isLoading"
                [columns]="[
                  { titulo: 'Razão Social', label: 'companyName' },
                  { titulo: 'CNPJ', label: 'cnpj' },
                  { titulo: 'Email', label: 'email' },
                  { titulo: 'Telefone', label: 'primaryPhone' },
                  { titulo: 'Status', label: 'status' },
                  { titulo: 'Estado', label: 'state' },
                  { titulo: 'Categoria', label: 'supplierCategory' }
                ]"
                [showSearch]="showSearch"
                [searchPlaceholder]="searchPlaceholder"
                [searchTerm]="filters.search"
                [clickable]="true"
                [actions]="actions"
                [disablePagination]="false"
                [totalItemsFromBackend]="totalItems"
                [enableSorting]="true"
                (sortChange)="onSortChange($event)"
                (rowClick)="edit($event)"
                (actionClick)="onActionClick($event)"
                (searchChange)="onSearchChange($event)"
                (pageChange)="onPageChange($event)"
                (pageSizeChange)="onPageSizeChange($event)">
                <app-button
                  table-header-action
                  text="Exportar CSV"
                  [color]="'var(--success-color, #16a34a)'"
                  [height]="'42px'"
                  className="export-btn"
                  (buttonClick)="exportToCSV()">
                </app-button>
                <app-button
                  *appHasPermission="'Suppliers.Create'"
                  table-header-action
                  text="Novo Fornecedor"
                  [color]="'var(--primary-light)'"
                  [height]="'42px'"
                  className="new-supplier-btn"
                  (buttonClick)="newSupplier()">
                </app-button>
              </app-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>
